/* =========================================================
   CROSS-SELLING MET DEZELFDE GRAVURE
   - Productpagina: vinkje "Maak er ook een bijpassende ... bij". Na het toevoegen
     van het hoofdartikel wordt het extra artikel toegevoegd met exact dezelfde
     gravuretekst (line item properties).
   - Winkelwagen: knop "Toevoegen" onder een gegraveerde regel; neemt de tekst
     van die regel over.
   Instellen: Thema-instellingen > Cross-selling. Markup: snippets/id4all-cross-sell.liquid
   ========================================================= */
(function () {
  'use strict';

  function geld(centen, formaat) {
    var bedrag = (centen / 100).toFixed(2);
    var komma = bedrag.replace('.', ',');
    var f = formaat || '€{{amount_with_comma_separator}}';
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, komma)
            .replace(/\{\{\s*amount\s*\}\}/, bedrag)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(centen / 100))
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(centen / 100));
  }

  function melding(box, tekst) {
    var m = box.querySelector('[data-cross-melding]');
    if (!m) return;
    m.textContent = tekst || '';
    m.hidden = !tekst;
  }

  function variantVan(box) {
    var v = box.querySelector('[data-cross-variant]');
    return v ? v.value : '';
  }

  /* Alleen zichtbare gravure-eigenschappen overnemen (geen _verborgen velden) */
  function schoon(props) {
    var uit = {};
    Object.keys(props || {}).forEach(function (k) {
      if (k.charAt(0) !== '_' && props[k] !== '' && props[k] != null) uit[k] = props[k];
    });
    return uit;
  }

  function voegToe(variantId, props, aantal) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: aantal || 1, properties: schoon(props) }] };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || res.message || 'Toevoegen mislukt');
      if (drawer && res.sections) {
        drawer.renderContents({ id: Number(variantId), sections: res.sections });
      } else if (/\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cross-sell', cartData: res });
      }
      return res;
    });
  }

  /* ---------- Prijs bijwerken bij keuze van maat/variant ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('select[data-cross-variant]');
    if (!sel) return;
    var box = sel.closest('[data-cross]');
    var opt = sel.options[sel.selectedIndex];
    var prijs = opt && parseInt(opt.getAttribute('data-prijs'), 10);
    melding(box, '');
    if (!prijs) return;
    var korting = parseInt(box.getAttribute('data-korting'), 10) || 0;
    var nieuw = prijs - Math.round(prijs * korting / 100); /* zelfde afronding als Shopify */
    var fmt = box.getAttribute('data-money-format');
    var p = box.querySelector('[data-cross-prijs]');
    if (p) {
      var extra = p.querySelector('.id4all-cross__korting');
      p.innerHTML = (korting > 0 ? '<s>' + geld(prijs, fmt) + '</s> ' : '') + '<strong>' + geld(nieuw, fmt) + '</strong>';
      if (extra) p.appendChild(document.createTextNode(' ')), p.appendChild(extra);
    }
    var check = box.querySelector('[data-cross-check]');
    if (check) check.checked = true;
  });

  /* ---------- Productpagina: maat verplicht als het vinkje aan staat ---------- */
  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('.product-form__submit');
    if (!knop) return;
    var scope = knop.closest('product-info, .product, section') || document;
    var box = scope.querySelector('[data-cross]:not(.id4all-cross--winkelwagen)');
    if (!box) return;
    var check = box.querySelector('[data-cross-check]');
    if (check && check.checked && !variantVan(box)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var sel = box.querySelector('select[data-cross-variant]');
      melding(box, sel ? sel.options[0].textContent : 'Kies een variant');
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (sel) sel.focus({ preventScroll: true });
    }
  }, true);

  /* ---------- Productpagina: na toevoegen hoofdartikel het extra artikel erbij ---------- */
  function koppel() {
    /* Let op: PUB_SUB_EVENTS is een const (constants.js), dus NIET window.PUB_SUB_EVENTS */
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form' || !event.cartData) return;
      var box = document.querySelector('[data-cross]:not(.id4all-cross--winkelwagen)');
      if (!box) return;
      var check = box.querySelector('[data-cross-check]');
      var variantId = variantVan(box);
      if (!check || !check.checked || !variantId) return;
      var data = event.cartData;
      var regel = data.properties ? data : (data.items && data.items[0]);
      if (!regel) return;
      check.checked = false; /* niet nog eens toevoegen bij een volgende klik */
      voegToe(variantId, regel.properties, 1).catch(function (err) {
        melding(box, err.message);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', koppel); else koppel();

  /* ---------- Winkelwagen: knop "Toevoegen" onder een gegraveerde regel ---------- */
  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-cross-add]');
    if (!knop) return;
    e.preventDefault();
    var box = knop.closest('[data-cross]');
    var variantId = variantVan(box);
    if (!variantId) {
      var sel = box.querySelector('select[data-cross-variant]');
      melding(box, sel ? sel.options[0].textContent : 'Kies een variant');
      if (sel) sel.focus();
      return;
    }
    var sleutel = box.getAttribute('data-line-key');
    knop.disabled = true;
    knop.classList.add('loading');
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var regel = (cart.items || []).find(function (i) { return i.key === sleutel; });
        if (!regel) throw new Error('Deze regel staat niet meer in je winkelwagen.');
        return voegToe(variantId, regel.properties, 1);
      })
      .catch(function (err) {
        melding(box, err.message);
        knop.disabled = false;
        knop.classList.remove('loading');
      });
  });
})();
